import { z } from "zod";
/** Contracts of sending a company's documents by mail (spec 015 Story 2). */
export const MAIL_SEND_STATUSES = [
    "draft",
    "discarded",
    "queued",
    "sent",
    "delivered",
    "bounced",
    "complained",
    "failed",
    "unknown",
];
export const MAIL_SEND_STATUS_LABELS = {
    draft: "Borrador",
    discarded: "Descartado",
    unknown: "Sin confirmar",
    queued: "En cola",
    sent: "Enviado",
    delivered: "Entregado",
    bounced: "Rebotado",
    complained: "Marcado como spam",
    failed: "No se pudo enviar",
};
export const DOCUMENT_KINDS = ["caja_iva_pdf", "libro_iva_pdf", "libro_iva_xlsx"];
export const DOCUMENT_KIND_LABELS = {
    caja_iva_pdf: "Caja IVA (PDF)",
    libro_iva_pdf: "Libro IVA (PDF)",
    libro_iva_xlsx: "Libro IVA (Excel)",
};
const year = z.number().int().min(2000).max(2100);
const month = z.number().int().min(1).max(12);
export const documentRefSchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("caja_iva_pdf"),
        year,
        month,
        snapshotVersion: z.number().int().min(1),
    }),
    z.object({
        kind: z.enum(["libro_iva_pdf", "libro_iva_xlsx"]),
        year,
        month,
        book: z.enum(["compras", "ventas", "ambos"]),
    }),
]);
/** Creates the draft: the document is rendered and stored now, so what is reviewed is what is sent. */
export const mailDraftSchema = z.object({ document: documentRefSchema });
/** Confirms a draft with what the person reviewed. */
export const mailConfirmSchema = z.object({
    recipients: z
        .array(z.string().trim().toLowerCase())
        .min(1, "Elegí al menos un destinatario.")
        .max(20),
    subject: z.string().trim().min(1, "El asunto no puede quedar vacío.").max(200),
    bodyText: z.string().trim().min(1, "El mensaje no puede quedar vacío.").max(5000),
});
//# sourceMappingURL=mail.js.map